export const SOCIAL_PLUGIN_POSITION = {
  HEAD_TAG: 'HEAD_TAG',
  BODY_TAG: 'BODY_TAG',
}

export const APP_LANG = {
  EN: 'en',
  VI: 'vi',
}
